import { render, staticRenderFns } from "./AppPromotionDetailsForm.vue?vue&type=template&id=07d5611e&"
import script from "./AppPromotionDetailsForm.vue?vue&type=script&lang=js&"
export * from "./AppPromotionDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./AppPromotionDetailsForm.vue?vue&type=style&index=0&id=07d5611e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports